import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Form, HStack, Link, Message, Panel, PanelGroup, Schema, Stack } from 'rsuite'
import Format, { TextField } from '@client/components/FormControls'
import { useAuth } from '@client/components/AuthProvider'
import toastMessage from '../utils/toastMessage'
import Overlay from './Overlay'

const { StringType } = Schema.Types

const formStyle = {
    backgroundColor: 'var(--color-2)',
    maxWidth: '90vw',
} as React.CSSProperties

type FormDataProps = { userName: string, password: string }

type ForgotPasswordProps = {
    onClose: () => void,
    onBack: () => void,
}

export default function ForgotPassword({ onClose, onBack }: ForgotPasswordProps) {
    const { t } = useTranslation()
    const format = Format()
    const formRef = useRef<FormDataProps>({ userName: '', password: '' })
    const { handleForgotPassword } = useAuth()
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState<FormDataProps>({ userName: '', password: '' })

    async function handleSubmit(n: any, e: any) {
        e?.preventDefault()

        try {
            setError('')
            setLoading(true)
            await handleForgotPassword(formData.userName)
            toastMessage(t("We have sent you an email with instructions to reset your password\nif the username exists in our system."), 'success', 5000)
            setTimeout(() => {
                onBack()
            }, 1000)
        } catch (err: any) {
            setError(t(err.message).toString())
        }
        finally {
            setLoading(false)
        }
    }

    const model = Schema.Model({
        userName: StringType().isRequired(format.required(t('Username'))),
    })

    return (
        <Overlay>
            <Panel header={t('Forgot password')} bordered style={formStyle}>
                <PanelGroup>
                    {error && <Message type="error">{error}</Message>}

                    <Form
                        id="login-form"
                        layout="vertical"
                        ref={formRef as any}
                        onChange={setFormData as any}
                        formValue={formData}
                        model={model}
                        onSubmit={handleSubmit}
                    >
                        <TextField name="userName" label={t('User name')} autoFocus={true} autoComplete='new-password' />

                        <Stack align="center" spacing={20} style={{ marginTop: 20, width: '100%', flexFlow: 'row wrap' }}>
                            <Button type="submit" appearance='ghost' disabled={loading}>{t('Reset password')}</Button>
                            <Stack.Item grow={1} textAlign="right">
                                <Link onClick={onBack}>{t('Back to login')}</Link>
                            </Stack.Item>
                        </Stack>
                    </Form>
                </PanelGroup>
            </Panel>
        </Overlay>
    )
}